const loginFields=[
    {
        labelText:"Email address",
        labelFor:"email-address",
        id:"email-address",
        name:"email",
        type:"email",
        autoComplete:"email",
        isRequired:true,
        placeholder:"Email address"   
    },
    {
        labelText:"Password",
        labelFor:"password",
        id:"password",
        name:"password",
        type:"password",
        autoComplete:"current-password",
        isRequired:true,
        placeholder:"Password"   
    }
]

const signupFields=[
    {
        labelText:"Tell me your name",
        labelFor:"Tell me your name",
        id:"ownername",
        name:"ownername",
        type:"text",
        autoComplete:"ownername",
        isRequired:true,
        placeholder:"Tell me your name"   
    },
    {
        labelText:"Your organization's name",
        labelFor:"Your organization's name",
        id:"orgname",
        name:"orgname",
        type:"text",
        autoComplete:"orgname",
        isRequired:true,
        placeholder:"Your organization's name"   
    },    
    {
        labelText:"Your Title",
        labelFor:"Your Title",
        id:"title",
        name:"title",
        type:"text",
        autoComplete:"title",
        isRequired:true,
        placeholder:"Your Title"   
    },    

    {
        labelText:"Your Marketing Team Size",
        labelFor:"Your Marketing Team Size",
        id:"teamsize",
        name:"teamsize",
        type:"text",
        autoComplete:"teamsize",
        isRequired:true,
        placeholder:"Your Marketing Team Size"   
    },    

    {
        labelText:"Your Domain (optional)",
        labelFor:"Your Domain",
        id:"domainname",
        name:"domainname",
        type:"text",
        autoComplete:"domainname",
        isRequired:false,
        placeholder:"Your Domain (optional)"
    },    
    
    {
        labelText:"Email ID",
        labelFor:"email-ID",
        id:"email-ID",
        name:"email",
        type:"email",
        autoComplete:"email",
        isRequired:true,
        placeholder:"Email ID"   
    },

    {
        labelText:"Contact Number",
        labelFor:"contactnumber",
        id:"contactnumber",
        name:"contactnumber",
        type:"number",
        autoComplete:"contactnumber",
        isRequired:true,
        placeholder:"Contact Number"   
    },
    {
        labelText:"How did you hear about us",
        labelFor:"sourceoflead",
        id:"sourceoflead",
        name:"sourceoflead",
        type:"text",
        autoComplete:"sourceoflead",
        isRequired:true,
        placeholder:"How did you hear about us"   
    },
    
]

export {loginFields,signupFields}
